import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { usePageMeta } from '../hooks/usePageMeta';
import ScrollToTop from '../components/ScrollToTop';
import Reveal from '../components/Reveal';
import Hero from '../components/Hero';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const Current = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  const cp = t.currentPage;
  usePageMeta({ title: cp.sectionTitle, description: cp.heroDescription, path: 'current' });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        size="lg"
        gradientClass="hero-gradient-current"
        eyebrow={cp.heroTitle}
        title={cp.heroSubtitle}
        description={cp.heroDescription}
      />

      {/* Geo-Image Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-stone-900 mb-6">
              {cp.sectionTitle}
            </h2>
          </Reveal>
          <Reveal delay={0.1} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
            <a
              href="https://geoatrium.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-amber-700 text-white font-semibold rounded-sm hover:bg-amber-800 transition-colors duration-200 shadow-md"
            >
              {cp.visitLink}
              <SafeIcon icon={FiExternalLink} className="ml-2 h-5 w-5" />
            </a>
          </Reveal>
        </div>
      </section>

      {/* Embedded Map Section */}
      <section className="pb-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="mb-6 text-center">
            <h3 className="font-serif text-xl font-bold text-stone-900">
              {cp.mapTitle}
            </h3>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-sm overflow-hidden shadow-2xl border border-stone-200">
              <iframe
                src="https://geoatrium.com/map"
                title="GeoAtrium Map"
                className="w-full border-0"
                style={{ height: '600px' }}
                loading="lazy"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </section>

      <ScrollToTop />
    </div>
  );
};

export default Current;
